import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { fromTokenAmount } from '../../../hooks/useSolana';
import { useGetTokenPriceQuery } from '../../../redux/api/public/tokens';
import { formatTokenPrice, formatUSD } from '../../../common/currency';
import { useEffect } from 'react';
import { openModal } from '../../../redux/slices/modals';
import PresentationalGift from './PresentationalGift';
import { useOutletContext } from 'react-router-dom';

const ClaimGift = () => {
  const { gift, token, isCreator, isReceiver } = useOutletContext();
  const tokenAmount = fromTokenAmount(gift?.tokenAmount, token?.decimals);

  const { data: tokenPrice } = useGetTokenPriceQuery(token?.address, {
    skip: !token,
    pollingInterval: 10000,
  });

  const dispatch = useDispatch();
  const tokenPriceUSD = tokenPrice?.priceUSDC;

  // Calculate current USD value based on token price
  const currentUsdValue =
    tokenPriceUSD && tokenAmount ? tokenPriceUSD * tokenAmount : 0;
  const navigate = useNavigate();

  const handleGiftClaimed = () => {
    const isClaimed = ['HTLC_CLAIMED', 'CLAIMED'].includes(gift?.status);

    if (isClaimed && !isReceiver) {
      // Redirect to discover page for claimed gifts that aren't theirs
      navigate('/app/discover');
    } else {
      dispatch(
        openModal({
          name: 'giftClaimed',
          props: {
            gift,
          },
        }),
      );
    }
  };

  // Auto-trigger giftClaimed modal and navigation if gift is already claimed
  useEffect(() => {
    if (gift && (gift.status === 'CLAIMED' || gift.status === 'HTLC_CLAIMED')) {
      handleGiftClaimed();
    }
  }, [gift]);

  if (!gift || !token) return <p>Error loading gift</p>;

  return (
    <PresentationalGift
      usdAmount={formatTokenPrice(currentUsdValue)}
      tokenSymbol={token?.symbol}
      tokenAmount={tokenAmount}
      token={token}
      giftCardImageUrl={gift?.imageUrl}
      message={gift?.message}
      onClick={handleGiftClaimed}
      animated={true}
      giftId={gift?.id}
      status={gift?.status}
      isCreator={isCreator}
      isReceiver={isReceiver}
    />
  );
};

export default ClaimGift;
